// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__37k-z","col":"styles_col__1i1W1"};